import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { UsersService } from '../../services/users.service';
import { Users } from '../../models/users';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { UserCreateComponent } from '../user-create/user-create.component';
import { PAGE_SIZE_OPTIONS, PAGE_LENGTH, ITEMS_PER_PAGE, CURRENT_PAGE } from 'src/app/shared/constants/pagination.constants';
import { MatSort } from '@angular/material/sort';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { FormControl } from '@angular/forms';
import { delay } from 'rxjs/operators';
import { LoaderService } from 'src/app/auth/services/loader.service';

const dialogConfig= new MatDialogConfig();
dialogConfig.disableClose = true;
dialogConfig.autoFocus = true;
// dialogConfig.maxHeight ="500px";

@Component({
  selector: 'app-users-details',
  templateUrl: './users-details.component.html',
  styleUrls: ['./users-details.component.css']
})
export class UsersDetailsComponent implements OnInit,AfterViewInit{
  
  @ViewChild('paginator', {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  
  public usersDisplayedColumns: string[] = ['name', 'email','org_name','role', 'status'];
  
  public usersDataSource:any;

  public PAGE_SIZE_OPTIONS_DATA:number[] = PAGE_SIZE_OPTIONS;

  public page_length:number = PAGE_LENGTH;

  public items_per_page:number = ITEMS_PER_PAGE;

  public current_page:number = CURRENT_PAGE;

  public hasRole:string = this.authservice.hasRole();
  public orgId:string = this.authservice.getOrgId();

  public advanceSearchCtrl = new FormControl('');


  constructor(private usersService:UsersService,
    private dialog:MatDialog,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private authservice:AuthenticationService,
    private loaderService:LoaderService
    ) { }

  ngOnInit(): void {
    this.loadIcon();
    this.getUsers();
    this.advancerSeach();

  }

  ngAfterViewInit(){
    if(this.usersDataSource != undefined ){
      this.usersDataSource.paginator = this.paginator;
      this.usersDataSource.sort = this.sort;
    }
  }

  loadIcon(){
    this.matIconRegistry.addSvgIcon(
      "filter",
      this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/SVG/filter.svg")
    );
  }
  
  addFilterParameters(){
    let filterParams = {};
    filterParams['page']=this.current_page;
    filterParams["per-page"]=this.items_per_page;
    filterParams["sort"] = "-id";
    return filterParams;
  }

  getUsers(){
    this.loaderService.isTableLoding.next(true);

    let filterParams = this.addFilterParameters();

    if(this.hasRole == '1'){
    }else{
      filterParams["org_id"] = this.orgId;
    }

    let searchParams = this.advanceSearchCtrl.value; 
    
    if( searchParams != '' && searchParams.length >= 3){
      filterParams['filter[name][like]'] = searchParams.trim();
    }

    this.usersService.getUsers(filterParams).subscribe(
      (res:any)=>{
        this.loaderService.isTableLoding.next(false);
        this.page_length = res.headers.get('X-Pagination-Total-Count');
        this.current_page = res.headers.get('X-Pagination-current-page');
        this.items_per_page = res.headers.get('X-Pagination-Per-Page');
        this.usersDataSource = new MatTableDataSource<Users[]>(res.body);
      }
    )
  }
  toggleStatus(user: any): void {
    user.isActive = !user.isActive; // Toggle the status

    this.usersService.updateUserStatus(user.id, user.isActive).subscribe({
        next: (response) => {
            console.log(`User status updated successfully:`, response);
        },
        error: (error) => {
            console.error('Failed to update user status:', error);
            user.isActive = !user.isActive; // Revert the status on error
        }
    });
}
  handlePage(e?: any):void {
    if(e){
      this.current_page = e.pageIndex+1;
      this.items_per_page = e.pageSize;
      this.page_length = e.length;
    }
    this.getUsers();
  }

  createUser(){
    dialogConfig.width ="40%";
    dialogConfig.data = {
      user_id : undefined
    };
    
    this.dialog.open(UserCreateComponent,dialogConfig);

    // UPDATE CONTACT DETAILS AFTER CREATING THE CONTACT
    this.dialog.afterAllClosed.subscribe(e=>{
       this.getUsers();
    });
  }

  updateUser(userId:string | number){
    dialogConfig.width ="40%";
    dialogConfig.data = {
      user_id : userId
    };

    console.log(userId);
    this.dialog.open(UserCreateComponent,dialogConfig);

    // UPDATE CONTACT DETAILS AFTER CREATING THE CONTACT
    this.dialog.afterAllClosed.subscribe(e=>{
       this.getUsers();
    });
  }

  advancerSeach(){
    this.advanceSearchCtrl.valueChanges
    .pipe(
      delay(300),
    )
    .subscribe(val=> {
        this.getUsers();
   });
}


}
